import type { Attribution } from "@quiz/quiz-core";

const paramsToCapture = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid", "ttclid"] as const;

export function captureAttribution(storageKey: string): Attribution {
  const existing = sessionStorage.getItem(storageKey);
  if (existing) return JSON.parse(existing) as Attribution;

  const search = new URLSearchParams(window.location.search);
  const attribution: Attribution = {
    referrer: document.referrer,
    landing_url: window.location.href
  };

  for (const key of paramsToCapture) {
    const value = search.get(key);
    if (value) attribution[key] = value;
  }

  sessionStorage.setItem(storageKey, JSON.stringify(attribution));
  return attribution;
}
